import { isRef } from 'vue'
import { isError } from '../is'

export const toString = (v?: any): string => {
  if (isRef(v)) return toString(v.value)

  if (isError(v)) {
    if (v.message) return toString(v.message)
    if (v.name) return toString(v.name)
    if (v.stack) return toString(v.stack)
    return JSON.stringify(v)
  }

  if (typeof v === 'number') {
    if (isNaN(v)) return '0'
    return v.toString()
  }
  if (typeof v === 'undefined' || v === null) return ''
  if (typeof v === 'string') return v
  try {
    if (v.toString) return v.toString()
  } catch (e) {
    console.error(e)
  }
  return JSON.stringify(v)
}
